module.exports = __webpack_public_path__ + "static/Raleway-Light-b1bdea561f247adc2c904f5b24a07c51.ttf";